import Cash from "cash-dom";

function interLeaveEffect(offset = -0.5) {
    let imageSelector = ".swiper-image";
    return {
        onProgress: swiper => {
            for (let i = 0; i < swiper.slides.length; i++) {
                let slide = swiper.slides[i];
                let translate = 0;
                let innerTranslate;
                let slideProgress = slide.progress;

                if (slideProgress > 0) {
                    translate = slideProgress * swiper.width;
                    innerTranslate = translate * offset;
                } else {
                    innerTranslate =
                        Math.abs(slideProgress * swiper.width) * offset;
                }

                Cash(slide).css({
                    transform: "translate3d(" + translate + "px,0,0)"
                });

                Cash(slide)
                    .find(imageSelector)
                    .css({
                        transform: "translate3d(" + innerTranslate + "px,0,0)"
                    });
            }
        },
        onTouchStart: swiper => {
            Cash(swiper.slides).css({ transition: "" });
        },
        onSetTransition: (swiper, speed) => {
            Cash(swiper.slides)
                .add(Cash(swiper.slides).find(imageSelector))
                .css({ transition: speed + "ms" });
        }
    };
}

export { interLeaveEffect };
